export const MAX_CHILD_AGE: number = 12;
export const MAX_INFANT_AGE: number = 2;
